import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useAdaptedProcesses = () => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontSizesByScreen = {
      1440: {
        title: 'h4' as const,
        description: 'b2' as const,
        subtitle: 'h4' as const,
        subDescription: 'b3' as const,
      },
      700: {
        title: 'h5' as const,
        description: 'b3' as const,
        subtitle: 'h5' as const,
        subDescription: 'b3' as const,
      },
    }
    return fontSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 700) return fontSizesByScreenSize[700]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 2500, min: 1280 },
      items: 8,
    },
    desktop: {
      breakpoint: { max: 1280, min: 768 },
      items: 6,
    },
    tablet: {
      breakpoint: { max: 768, min: 480 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 480, min: 0 },
      items: 2,
    },
  }

  return {
    fontSizes,
    responsive,
  }
}
